module.exports = __webpack_public_path__ + "static/media/brugnieuws.a5e73d25.png";